export default {
  title: "",
  subtitle: "",
  path: "bank_transaction_show",
  paragraph: "Returns the bank transfer details.",
  request: {
      method: "GET",
      endpoint: "/wires/:id",
           responses:{
        "data": {
            "value": "574.84",
            "unretryable": null,
            "to_bank_account": {
                "routing_number": null,
                "pix_info": null,
                "owner_name": "André Freitas Lopes",
                "owner_document_type": null,
                "owner_document_number": "01472583691",
                "nickname": null,
                "intermediary_bank_account": null,
                "id": "102518ca-5d8a-443f-b131-e47d99bc4d0d",
                "iban": null,
                "currency": "BRL",
                "company": {
                    "social_name": "John Doe",
                    "phone_number": "99812-1212",
                    "id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
                    "fiscal_country": "BR",
                    "document_type": "cpf",
                    "document_number": "05069869183",
                    "company_name": "Company & CIA"
                },
                "branch_number": "0031",
                "branch_country": "BR",
                "bank": {
                    "swift": null,
                    "name": "Código Banco Beg S.A.",
                    "ispb": null,
                    "id": "f9dcd833-a4a8-4595-8f5a-b63b0a98292d",
                    "country": "BRA",
                    "code": "031"
                },
                "account_type": "conta-corrente",
                "account_number": "85296",
                "aba": null
            },
            "status": "success",
            "inserted_at": "2025-02-05T16:25:07.062903",
            "id": "e027fc20-42d0-4da6-92d8-60893509b531",
            "currency": "BRL"
        }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Bank transfer UUID"
    }
  ]
}




// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/BankTransferShow.js